import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Name of employee: ", -1);
const _hoisted_3 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_4 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Stage:", -1);
const _hoisted_6 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_7 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Assignee:", -1);
const _hoisted_9 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_10 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Status:", -1);
const _hoisted_12 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_13 = {
    key: 0,
    class: "flex justify-end"
};
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("b", null, "*Please ensure that all mandatory fields are completed before submitting for approval", -1);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("b", null, "*For compatible browsers please review this link. If your browser is\n        not compatible it may effect the text you see within multi line text\n        boxes and /or the speed of the people search.", -1);
const _hoisted_17 = { class: "bg-white rounded-lg p-4 w-full" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_activity_feed = _resolveComponent("activity-feed");
    const _component_LeaverHROpsApprovalChat = _resolveComponent("LeaverHROpsApprovalChat");
    const _component_formLayout = _resolveComponent("formLayout");
    const _component_CheckIcon = _resolveComponent("CheckIcon");
    const _component_ModalWindow = _resolveComponent("ModalWindow");
    const _component_SendLeaverLetterModal = _resolveComponent("SendLeaverLetterModal");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_formLayout, {
            "nav-item-config": _ctx.navItems,
            "current-nav-item": _ctx.currentNavItem,
            "form-point": _ctx.formPoint,
            "form-name": "leaverForm",
            "display-header": _ctx.formData?.status && _ctx.formData.status !== 'DRAFT',
            "display-timeline": _ctx.disableForm || _ctx.editable,
            "display-footer": _ctx.disableForm || _ctx.editable,
            "print-mode": _ctx.inPrintMode,
            "form-data": _ctx.formData,
            onSetCurrentNavItem: _ctx.setCurrentNavItem
        }, {
            pageTitle: _withCtx(() => [
                _createTextVNode("Leaver notification")
            ]),
            header: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_3, _toDisplayString(_ctx.formData.formOne?.name || '-'), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_6, _toDisplayString(_ctx.currentStage?.displayName), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_9, _toDisplayString(_ctx.formData?.currentAssigneeEmail || '-'), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_12, _toDisplayString(_ctx.formData?.status || '-'), 1)
                ]),
                _createTextVNode(),
                (_ctx.profile?.ADMIN || _ctx.profile?.H2R || _ctx.profile?.RESOURCING)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.handleReassign && _ctx.handleReassign(...args)))
                        }, "Re-assign")
                    ]))
                    : _createCommentVNode("", true)
            ]),
            pageSubtitle: _withCtx(() => [
                _hoisted_14,
                _hoisted_15,
                _createTextVNode(),
                _hoisted_16
            ]),
            navFooter: _withCtx(() => [
                (_ctx.currentUserIsAssigned && _ctx.formData?.currentStageName && ['leaver.notifyHROps'].includes(_ctx.formData.currentStageName) && !_ctx.editable)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(["w-full text-center px-4 py-2 mb-2 rounded-md text-white bg-blue-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat", { 'bg-red-700 border-red-900': _ctx.editable }]),
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.handleMakeEditable && _ctx.handleMakeEditable(...args)))
                    }, "\n        Edit\n      ", 2))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.currentUserIsAssigned && (_ctx.disableForm || _ctx.editable) && _ctx.formData?.currentStageName === 'leaver.notifyH2RNewLeaver')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.handleAssign && _ctx.handleAssign(...args)))
                    }, "\n        Assign Admin\n      "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.currentUserIsAssigned && (_ctx.disableForm || _ctx.editable) && _ctx.formData?.currentStageName === 'leaver.notifyHROps')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[3] || (_cache[3] =
                            //@ts-ignore
                            (...args) => (_ctx.handleModalOpen && _ctx.handleModalOpen(...args)))
                    }, _toDisplayString(_ctx.editable ? 'Save Edits' : 'Action'), 1))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                ((_ctx.currentUserIsAssigned && (_ctx.disableForm || _ctx.editable) && _ctx.formData?.currentStageName === 'leaver.notifyH2RAdminAssigned') ||
                    (_ctx.formData?.currentStageName === 'leaver.notifyH2RAdminAssigned' && _ctx.currentNavItem?.name === 'formFive'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[4] || (_cache[4] =
                            //@ts-ignore
                            (...args) => (_ctx.handleConfirmLeaver && _ctx.handleConfirmLeaver(...args)))
                    }, "\n        Confirm Leaver\n      "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.currentUserIsAssigned && _ctx.disableForm && _ctx.formData?.currentStageName === 'leaver.notifyHMMoreInfoNeeded')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[5] || (_cache[5] =
                            //@ts-ignore
                            (...args) => (_ctx.handleRespondMoreInfo && _ctx.handleRespondMoreInfo(...args)))
                    }, "\n        Action\n      "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.currentUserIsDirectlyAssigned &&
                    _ctx.disableForm &&
                    _ctx.formData?.currentStageName === 'leaver.notifyH2R')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 5,
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[6] || (_cache[6] =
                            //@ts-ignore
                            (...args) => (_ctx.handleCompleteRequest && _ctx.handleCompleteRequest(...args)))
                    }, "\n        Complete Request\n      "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                ((_ctx.formData?.currentStageName && _ctx.formData.currentStageName !== 'DRAFT') &&
                    (_ctx.profile?.ADMIN || _ctx.profile?.H2R || _ctx.profile?.RESOURCING || _ctx.currentUserIsAssigned) &&
                    _ctx.formData.currentStageName !== 'leaver.notifyH2R' &&
                    _ctx.formData.currentStageName !== 'leaver.complete')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 6,
                        class: "w-full mt-2 text-center px-4 py-2 rounded-md text-white bg-red-700 hover:bg-red-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[7] || (_cache[7] =
                            //@ts-ignore
                            (...args) => (_ctx.handleCancelLeaver && _ctx.handleCancelLeaver(...args)))
                    }, "\n        Cancel leaver\n      "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.formData?.currentStageName === 'DRAFT')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 7,
                        class: "w-full mt-2 text-center px-4 py-2 rounded-md text-white bg-red-700 hover:bg-red-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.showDeleteModal = true))
                    }, "\n        Delete Draft\n      "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.canPrint)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 8,
                        class: "w-full text-center mt-2 px-4 py-2 rounded-md text-white bg-blue-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[9] || (_cache[9] =
                            //@ts-ignore
                            (...args) => (_ctx.print && _ctx.print(...args)))
                    }, "\n        Print/Save to PDF\n      "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.canSendLeaverLetter)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 9,
                        class: "w-full text-center mt-2 px-4 py-2 rounded-md text-white bg-green-700 hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.showSendLeaverLetterModal = true))
                    }, "\n        Send letter\n      "))
                    : _createCommentVNode("", true)
            ]),
            main: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentNavItem?.component), {
                    "disable-form": _ctx.disableForm,
                    "config-items": _ctx.configItems,
                    data: _ctx.formData,
                    "reason-resignation": _ctx.formData?.formThree?.reasonResignation ?? '',
                    onSubmitForm: _ctx.handleSubmitForm,
                    onSubmitLeaver: _ctx.handleSubmitLeaver
                }, null, 40, ["disable-form", "config-items", "data", "reason-resignation", "onSubmitForm", "onSubmitLeaver"]))
            ]),
            printArea: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (comp) => {
                    return (_openBlock(), _createBlock(_resolveDynamicComponent(comp?.component), {
                        key: comp.name,
                        "disable-form": true,
                        "config-items": _ctx.configItems,
                        data: _ctx.formData
                    }, null, 8, ["config-items", "data"]));
                }), 128))
            ]),
            timeline: _withCtx(() => [
                (_ctx.formData.activityList)
                    ? (_openBlock(), _createBlock(_component_activity_feed, {
                        key: 0,
                        "activity-list": _ctx.formData?.activityList
                    }, null, 8, ["activity-list"]))
                    : _createCommentVNode("", true)
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                    (_ctx.formData.shortId)
                        ? (_openBlock(), _createBlock(_component_LeaverHROpsApprovalChat, {
                            key: 0,
                            "form-data": _ctx.formData,
                            "doc-type": "LEAVER"
                        }, null, 8, ["form-data"]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _: 1
        }, 8, ["nav-item-config", "current-nav-item", "form-point", "display-header", "display-timeline", "display-footer", "print-mode", "form-data", "onSetCurrentNavItem"]),
        _createTextVNode(),
        (_ctx.showModal)
            ? (_openBlock(), _createBlock(_component_ModalWindow, {
                key: 0,
                onClose: _ctx.handleModalClose
            }, {
                icon: _withCtx(() => [
                    _createVNode(_component_CheckIcon, {
                        class: "h-6 w-6 text-green-600",
                        "aria-hidden": "true"
                    })
                ]),
                title: _withCtx(() => [
                    _createTextVNode("Leaver Approval")
                ]),
                subtitle: _withCtx(() => [
                    _createTextVNode("What would you like to do with this Leaver?")
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                        onClick: _cache[11] || (_cache[11] =
                            //@ts-ignore
                            (...args) => (_ctx.handleHROpsApproval && _ctx.handleHROpsApproval(...args)))
                    }, "\n        Approve\n      "),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        class: "w-full text-center mt-2 px-4 py-2 rounded-md text-white bg-red-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[12] || (_cache[12] =
                            //@ts-ignore
                            (...args) => (_ctx.handleRejectLeaver && _ctx.handleRejectLeaver(...args)))
                    }, "\n        Reject\n      ")
                ]),
                _: 1
            }, 8, ["onClose"]))
            : _createCommentVNode("", true),
        _createTextVNode(),
        (_ctx.showDeleteModal)
            ? (_openBlock(), _createBlock(_component_ModalWindow, {
                key: 1,
                onClose: _cache[15] || (_cache[15] = ($event) => (_ctx.showDeleteModal = false))
            }, {
                icon: _withCtx(() => [
                    _createVNode(_component_CheckIcon, {
                        class: "h-6 w-6 text-green-600",
                        "aria-hidden": "true"
                    })
                ]),
                title: _withCtx(() => [
                    _createTextVNode("Delete Draft")
                ]),
                subtitle: _withCtx(() => [
                    _createTextVNode("Are you sure you want to delete this draft?")
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                        onClick: _cache[13] || (_cache[13] =
                            //@ts-ignore
                            (...args) => (_ctx.handleDeleteDraft && _ctx.handleDeleteDraft(...args)))
                    }, "\n        Delete\n      "),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        class: "w-full text-center mt-2 px-4 py-2 rounded-md text-white bg-red-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[14] || (_cache[14] = ($event) => (_ctx.showDeleteModal = false))
                    }, "\n        Cancel\n      ")
                ]),
                _: 1
            }))
            : _createCommentVNode("", true),
        _createTextVNode(),
        (_ctx.showSendLeaverLetterModal && _ctx.formData?.docId && _ctx.formData?.requestedBy)
            ? (_openBlock(), _createBlock(_component_SendLeaverLetterModal, {
                key: 2,
                "doc-id": _ctx.formData.docId,
                "doc-owner": _ctx.formData.requestedBy,
                onClose: _cache[16] || (_cache[16] = ($event) => (_ctx.showSendLeaverLetterModal = false)),
                onSent: _ctx.handleLeaverLetterSent
            }, null, 8, ["doc-id", "doc-owner", "onSent"]))
            : _createCommentVNode("", true)
    ], 64));
}
